import styled from "styled-components";

export const UploadImageStyled = styled.div`
  label {
  }
`;

export const UploadContent = styled.div<any>`
  position: relative;
  width: 100%;
  height: 220px;
  top: -25px;
  background: #f5f5f5;
  border-radius: 16px;
  border: 1px solid ${(props) => (props.error ? "red" : "#f1f1f1")};
  overflow: hidden;
  .uploadIcon {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    svg {
      width: 30px;
      height: 30px;
    }
    p {
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      color: #bdbdbd;
    }
  }
  .loaderContent {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    .MuiCircularProgress-root.MuiCircularProgress-indeterminate {
      width: 30px !important;
      height: 30px !important;
    }
  }
  label {
    width: 100px;
    height: 100%;
    position: absolute;
    // top: ${(props) => (props.img ? "52%" : "0")};
    // left: ${(props) => (props.part ? "0" : props.img ? "41.4%" : "0")};
    top: 0;
    left: 36%;
    right: 0;
    bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      cursor: pointer;
    }
    input {
      display: none;
    }
  }
  label.loading {
    opacity: 0.4;
  }
`;

export const UploadedImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 10px 0;
  .img {
    width: 180px;
    height: 180px !important;
    // padding: 16px;
    vertical-align: middle;
    display: none;
    justify-content: center;

    .uploadImage {
      width: 100%;
      height: 100%;
      // max-height: 120px !important;
      object-fit: cover;
    }
  }
  .img.active {
    display: flex;
  }
  .action {
    width: 45%;
    height: 100%;
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 8px;

    .uploaded {
      text-align: center;
      width: 60%;
      height: 100%;
    }
    .change {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40%;
      height: 100%;
      svg {
        fill: #bdbdbd;
        font-size: 28px;
      }
    }
  }
  .action.active {
    display: none;
  }
`;
